/**
 * Environment Configuration for RBAC Frontend
 * Automatically detects environment and sets appropriate base URLs
 */

// Environment detection + fallback
const FALLBACK_ENV = 'local';
const allowedEnvs = ['local', 'devdev', 'dev', 'stage', 'prod'];
const rawEnv = process.env.REACT_APP_ENV_BUILD;
const currentEnv = allowedEnvs.includes(rawEnv) ? rawEnv : FALLBACK_ENV;

// Optional: log when falling back
if (rawEnv !== currentEnv) {
  console.warn(`REACT_APP_ENV_BUILD "${rawEnv}" invalid/missing; falling back to "${currentEnv}"`);
}

// Base URL configuration for different environments
const ENV_CONFIG = {
  local: {
    baseUrl: 'http://localhost:5001/trustautodev-7ff75/asia-south1',
    region: 'asia-south1',
    projectId: 'trustautodev-7ff75',
  },
  devdev: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://asia-south1-trustautodev-7ff75.cloudfunctions.net',
    region: 'asia-south1',
    projectId: 'trustautodev-7ff75',
  },
  dev: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://asia-south1-trustautodevenv.cloudfunctions.net',
    region: 'asia-south1',
    projectId: 'trustautodevenv',
  },
  stage: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://asia-south1-trustautostaging.cloudfunctions.net',
    region: 'asia-south1',
    projectId: 'trustautostaging',
  },
  prod: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://asia-south1-trustautoprod.cloudfunctions.net',
    region: 'asia-south1',
    projectId: 'trustautoprod',
  }
};

const customBaseUrl = process.env.REACT_APP_API_BASE_URL;
const selected = ENV_CONFIG[currentEnv]; // guaranteed defined

export const config = {
  environment: currentEnv,
  ...selected,
  baseUrl: customBaseUrl || selected.baseUrl,
};

export const { baseUrl, region, projectId } = config;

if (currentEnv === 'devdev' || currentEnv === 'local') {
  console.log('🔧 RBAC Frontend Environment Configuration:', { environment: currentEnv, baseUrl, region, projectId });
}

export default config;
